module.exports = __webpack_public_path__ + "images/banners/item_top/item_top_banner_btn_30ff2c10686e74e2c3f5a9e08a36a3c6.png";